// Map an index short-code (from /api/indices) to its TradingView chart URL.
// Falls back to a sensible NSE:<code> guess so new indices still open.
const TV_INDEX_MAP = {
  NIFTY: "NSE:NIFTY",
  SENSEX: "BSE:SENSEX",
  BANKNIFTY: "NSE:BANKNIFTY",
  MIDCAP100: "NSE:CNXMIDCAP",
  INDIAVIX: "NSE:INDIAVIX",
  DOWJONES: "TVC:DJI",
  NASDAQ: "NASDAQ:IXIC",
  SP500: "TVC:SPX",
  DOWFUT: "CME_MINI:YM1!",
  NASDAQFUT: "CME_MINI:NQ1!",
  SPFUT: "CME_MINI:ES1!",
  CRUDE: "NYMEX:CL1!",
  GOLD: "COMEX:GC1!",
  SILVER: "COMEX:SI1!",
  DXY: "TVC:DXY",
};

export function tradingViewIndexUrl(code) {
  const tv = TV_INDEX_MAP[code] || `NSE:${code}`;
  return `https://in.tradingview.com/chart/?symbol=${encodeURIComponent(tv)}`;
}

export function tradingViewStockUrl(symbol) {
  const clean = (symbol || "").replace(".NS", "");
  return `https://in.tradingview.com/chart/?symbol=NSE%3A${encodeURIComponent(clean)}`;
}

// Screener.in is the de-facto fundamental-analysis tool for Indian retail —
// far richer than yfinance for ratios, history and shareholding. We strip the
// `.NS` suffix because Screener uses the bare NSE ticker in its URLs.
export function screenerStockUrl(symbol) {
  const clean = (symbol || "").replace(".NS", "").toUpperCase();
  return `https://www.screener.in/company/${encodeURIComponent(clean)}/`;
}
